import { Component, OnInit } from '@angular/core';
import { FaqSectionModel, FaqSectionQuery } from '@fgb/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent implements OnInit {
  showPlaceholder$: Observable<boolean>;

  constructor(private faqSectionQuery: FaqSectionQuery) {}

  ngOnInit() {
    this.showPlaceholder$ = combineLatest([this.faqSectionQuery.selectLoading(), this.faqSectionQuery.selectAll()]).pipe(
      map(([loading, faqSections]) => !loading && !this.hasItems(faqSections))
    );
  }

  hasItems(faqSections: FaqSectionModel[]): boolean {
    return !!faqSections?.some((faqSection) => !!faqSection.SectionItems?.length);
  }
}
